<template>
  <v-card
    class="mx-auto px-5 p-postEditor__contentWrapper"
    outlined
  >
    <div>
      <div class="p-postEditor__toolBar">
        <v-row v-if="sorting" style="width: 100%">
          <v-col cols="10">
            <v-btn color="primary" @click="sorting = false">
              並び替え完了
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="!sorting" style="width: 100%">
          <v-col cols="10">
            <item-add-btn-group />
          </v-col>
          <v-col cols="2">
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  tile
                  small
                  outlined
                  class="ma-1"
                  color="blue-grey"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small left>mdi-cog</v-icon>
                  ツール
                </v-btn>
              </template>
              <v-card tile flat>
                <v-list nav dense>
                  <v-list-item @click="convertDialog = true">
                    <v-list-item-icon class="mr-2">
                      <v-icon>mdi-file-document-edit-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>docsから貼り付ける</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <HtmlCopyBtn :post-id="postId" />
                  <ItemListCopyBtn />
                  <v-list-item @click="sorting = true">
                    <v-list-item-icon class="mr-2">
                      <v-icon>mdi-sort</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>並び替え</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="deleteAllItems">
                    <v-list-item-icon class="mr-2">
                      <v-icon color="error">mdi-delete-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="error--text">
                      <v-list-item-title>記事アイテム全削除</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
      </div>
      <SortingItemContainer v-if="sorting" />
      <PostContentItemLayout v-if="!sorting" :items="items" />
    </div>
    <v-dialog v-model="convertDialog" persistent max-width="800">
      <v-card>
        <v-card-title>
          <v-spacer />
          <v-btn icon @click="convertDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle>
          docsからコピーした内容を記事アイテムに変換します。<br />
          エディタ内にコピーした内容を貼り付けたあと、"記事アイテムに変換"を押してください。
        </v-card-subtitle>
        <v-card-text>
          <html-convert-editor
            :content="htmlContent"
            @change="reflectContent"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click="convertHtml">
            記事アイテムに変換
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import ItemAddBtnGroup from '@/components/postEditor/parts/ItemAddBtnGroup'
import HtmlCopyBtn from '@/components/postEditor/parts/contentField/HtmlCopyBtn'
import ItemListCopyBtn from '@/components/postEditor/parts/contentField/ItemListCopyBtn'
import { mapState } from 'vuex'
import HtmlConvertEditor from '@/components/commons/HtmlConvertEditor'
import PostContentItemLayout from '@/components/postEditor/parts/PostContentItemLayout'
import SortingItemContainer from '@/components/postEditor/parts/sortField/SortingItemContainer'

export default {
  name: 'PostContentField',
  components: {
    SortingItemContainer,
    PostContentItemLayout,
    ItemAddBtnGroup,
    HtmlConvertEditor,
    HtmlCopyBtn,
    ItemListCopyBtn
  },
  data () {
    return {
      data: null,
      convertDialog: false,
      htmlContent: '',
      sorting: false
    }
  },
  computed: {
    ...mapState({
      postId: (state) => state.PostEditor.post.id,
      items: (state) => state.PostEditor.post.items
    })
  },
  methods: {
    deleteAllItems () {
      if (confirm('全ての記事アイテムが削除されます。本当に削除しますか？')) {
        this.$store.commit('PostEditor/DELETE_ALL_ITEMS')
        this.$store.commit('PostEditor/SET_POST_SAVED_TO_DB', false)
      }
    },
    reflectContent (value) {
      this.htmlContent = value
    },
    convertHtml () {
      const parser = new DOMParser()
      const htmlDoc = parser.parseFromString(this.htmlContent, 'text/html')
      const itemList = htmlDoc.querySelectorAll('h2,h3,h4,p')
      itemList.forEach((item) => {
        if (!item.textContent) return

        const varietyFormat = (item) => {
          if (
            item.localName === 'h2' ||
            item.localName === 'h3' ||
            item.localName === 'h4'
          ) {
            return 'heading'
          } else if (item.localName === 'p') {
            return 'text'
          } else {
            return ''
          }
        }
        const itemableAttributesFormat = (item) => {
          if (
            item.localName === 'h2' ||
            item.localName === 'h3' ||
            item.localName === 'h4'
          ) {
            return {
              content: item.innerText,
              headingType: Number(item.localName.replace(/h/g, ''))
            }
          } else if (item.localName === 'p') {
            return {
              content: `<p>${item.innerText}</p>`
            }
          } else {
            return {}
          }
        }
        const payload = {
          id: null,
          variety: varietyFormat(item),
          order: null,
          _destroy: false,
          newItem: true,
          itemableAttributes: itemableAttributesFormat(item)
        }
        this.$store.commit('PostEditor/ADD_ITEM_TO_END', payload)
      })
      this.convertDialog = false
      this.htmlContent = ''
    }
  }
}
</script>

<style scoped>
.postEditor__contentWrapper {
  position: relative;
  padding-bottom: 100px;
}
.p-postEditor__contentWrapper {
  margin-bottom: 50px;
}
.itemGallary {
  overflow-y: auto;
}
</style>
